import { Card, CardBody, Col } from "reactstrap";
import CommonCardFooter from "../Common/CommonCardFooter";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OfferStyleBorders } from "../../../../Constant";
import { OFFER_BORDER_STYLE } from "../../../../Data/FormControl/MegaOptions";
import OfferStyleBorderForm from "./OfferStyleBorderForm";

const OfferStyleBorder = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={OfferStyleBorders} span={OFFER_BORDER_STYLE} />
        <CardBody className="megaoptions-border-space-sm">
          <OfferStyleBorderForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="success" color2="light-success" btn2Class='list-light-success' />
      </Card>
    </Col>
  )
};

export default OfferStyleBorder;
